const AUTH_ERROR_RELOAD_KEY = 'auth_error_reload_count';
const AUTH_ERROR_RELOAD_TIMESTAMP_KEY = 'auth_error_reload_timestamp';
const MAX_AUTH_ERROR_RELOADS = 3;
const AUTH_ERROR_RELOAD_WINDOW_MS = 60_000; // 1 minute

export function shouldReloadOnAuthError(): boolean {
  try {
    const countStr = sessionStorage.getItem(AUTH_ERROR_RELOAD_KEY);
    const timestampStr = sessionStorage.getItem(AUTH_ERROR_RELOAD_TIMESTAMP_KEY);

    const now = Date.now();
    const parsedCount = countStr ? Number.parseInt(countStr, 10) : 0;
    const parsedTimestamp = timestampStr ? Number.parseInt(timestampStr, 10) : 0;

    // Handle invalid stored values by treating them as 0
    const count = Number.isNaN(parsedCount) ? 0 : parsedCount;
    const timestamp = Number.isNaN(parsedTimestamp) ? 0 : parsedTimestamp;

    // Reset count if outside the time window
    if (now - timestamp > AUTH_ERROR_RELOAD_WINDOW_MS) {
      sessionStorage.setItem(AUTH_ERROR_RELOAD_KEY, '1');
      sessionStorage.setItem(AUTH_ERROR_RELOAD_TIMESTAMP_KEY, String(now));
      return true;
    }

    // Check if we've exceeded the max reload attempts
    if (count >= MAX_AUTH_ERROR_RELOADS) {
      return false;
    }

    // Increment the count
    sessionStorage.setItem(AUTH_ERROR_RELOAD_KEY, String(count + 1));
    return true;
  } catch {
    // If sessionStorage is unavailable, allow one reload
    return true;
  }
}
